import { ChatType, RelationshipEnum, SendingStatus, ServiceType, Sex } from ".";
import { MsgStatus } from "./wecom";

/**
 * WhatsApp 消息类型
 * 独立数字枚举，不复用 WecomMsgType（企微字段是 msgtype，WhatsApp 字段是 msg_type）
 * 仅支持三种：文本、图片、文件
 */
export enum WhatsAppMsgType {
  /** 文本 */
  TEXT_0 = 0,
  /** 图片 */
  QW_IMAGE = 101,
  /** 文件 */
  QW_FILE = 102,
}

export type WhatsAppContact = {
  id?: string;
  account: string;
  avatar: string;
  name: string;
  nickname: string;
  remark: string;
  mobile: string;
  sex: Sex;
  user_id: string;
  from_user_id: string;
  chat_id?: string;
  service_type: ServiceType;
  relationship?: RelationshipEnum;
  renderId?: string;
};

/** WhatsApp 仅单聊，会话类型固定为 SINGLE */
export enum WhatsAppContactType {
  /** 单聊 */
  SINGLE = "SINGLE",
}

type ExcludeKeys<T, U> = Exclude<keyof T, keyof U>;

type WhatsAppMessageCommonType = {
  chat_id: string;
  another_id: string;
  msg_server_id: string;
  msg_unique_identifier: string;
  msg_type: WhatsAppMsgType;
  request_key?: string;
  sender_id: string;
  timestamp: number;
  from_user_id?: string;
  to_id?: string;
  chat_type?: ChatType;
  /** 消息发送状态 */
  sending_status?: SendingStatus;
  /** 调用发送消息方法时的所有参数，用于发送失败时重新调用发送方法发送 */
  send_message_params?: Record<string, any>;
  /** ai回复的ID */
  robot_task_id?: string;
  /** 是否点赞 */
  positive?: boolean;
  /** 消息状态 */
  msg_status?: MsgStatus;
  robotId?: string;
  /** 纠偏知识id */
  rectifyId?: string;
  /** 发送系统用户名 */
  send_sys_user_name?: string;
};

export type WhatsAppMessageBaseType<T extends object> =
  WhatsAppMessageCommonType & {
    [P in ExcludeKeys<T, WhatsAppMessageCommonType>]?: T[P];
  };

export type WhatsAppTextMessageType = WhatsAppMessageBaseType<{
  content: string;
}>;

export type WhatsAppImageMessageType = WhatsAppMessageBaseType<{
  file_url: string;
  file_name: string;
}>;

export type WhatsAppFileMessageType = WhatsAppMessageBaseType<{
  file_url: string;
  file_name: string;
  file_size?: number;
}>;

export type WhatsAppMessageType =
  | WhatsAppTextMessageType
  | WhatsAppImageMessageType
  | WhatsAppFileMessageType;

export type WhatsAppConversationDataType = {
  chat_id: string;
  team_id?: string;
  name?: string;
  avatar?: string;
  last_message: WhatsAppMessageType;
  chat_type: WhatsAppContactType;
  from_user_id?: string;
  // 是否置顶
  is_top?: number;
  // 未读数
  unread?: number;
  // 是否屏蔽
  is_shield?: number;
  conversation_robot_relation?: {
    robotId?: string;
  };
  // 是否托管
  is_trusteeship?: boolean;
  // 当前会话的对象
  another_id: string;
  /** 联系人信息 */
  contact?: WhatsAppContact;
};
